import { Module } from "vuex";
import { RootState } from "@/store/types";
import { ServiceScheduleState } from "./types";
import { getters } from "./getters";
import { mutations } from "./mutations";
import moment from "moment";

const currentDate = new Date();

const state: ServiceScheduleState = {
  clinicId: "",
  date:  new Date().toString(),
  searchDate:  "",
  time: null,
  service: null,
  cpf: "",
  appointmentDate: "",
  patient: null,
  formPatientData: {},
};

export const serviceSchedule: Module<ServiceScheduleState, RootState> = {
  state,
  getters,
  mutations,
};
